import { RootState } from '~/store';
import blueprintsState from '~/utils/blueprintsState';

const dialogKeys = [
    'isRulesDialogOpen',
    'isBoosterDialogOpen',
    'isWelcomeDialogOpen',
    'isErrorDialogOpen',
    'isVideoPlayerVisible',
    'isBuyoutDialogOpen',
    'isFinalDialogOpen',
    'isMultipleBuyDialogVisible',
    'isStartBuyDialogVisible',
];

const hasOpenedDialogs = (getState: () => RootState): boolean => {
    const state = getState();
    const openedDialogs: Array<string> = [];
    for (const key in state.dialogs) {
        if (dialogKeys.includes(key) && state.dialogs[key] === true) {
            openedDialogs.push(key);
        }
    }
    return openedDialogs.length > 0;
};

const animationInterrupter = (getState: () => RootState, level: number): Promise<true> => {
    return new Promise((resolve) => {
        const listener = setInterval(() => {
            const state = getState();
            const blueplrintLevelAnimationComplete = blueprintsState.isLevelComplete(level);
            const levelHigherThenBlueprints = level > state.app.blueprintsCount;

            if (!hasOpenedDialogs(getState) && (blueplrintLevelAnimationComplete || levelHigherThenBlueprints)) {
                clearInterval(listener);
                resolve(true);
            }
        }, 1000 / 30);
    });
};

export default animationInterrupter;
